export enum ThemeVariant {
  LIGHT = 0,
  DARK = 1,
}
